import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as PDT_INTERFACE from '../interfaces/PDT.interface';

export function FormToPDT(
    accessTicket: FORM_INTERFACE.accessTicketInterface,
    headquartersName: string,
) {
    const PDTDetail: PDT_INTERFACE.PDTInterface = {
        id: 123456,
        name: '',
        criticality: '',
        media: 0,
        priority: 0,
        group: 0,
        team: 0,
        userCreator: 0,
        contactId: 0,
        creationDate: '',
        closingDate: '',
        startDate: '',
        endDate: '',
        customerId: 0,
        customerCategory: 0,
        typing: getTyping(accessTicket),
        customer: getCustomer(accessTicket),
        accessPermission: getAccessPermission(accessTicket, headquartersName),
    };
    return PDTDetail;
}

function getAccessPermission(
    accessTicket: FORM_INTERFACE.accessTicketInterface,
    headquartersName: string,
) {
    const accessPermission: PDT_INTERFACE.accessPermissionInterface = {
        id: 0,
        date: '',
        startDate:
            accessTicket.generalInformation.fromDateVal +
            ' ' +
            accessTicket.generalInformation.fromTimeVal,
        endDate:
            accessTicket.generalInformation.toDateVal +
            ' ' +
            accessTicket.generalInformation.toTimeVal,
        emergency: accessTicket.generalInformation.emergencyChangeReason != '',
        serviceInterruption: accessTicket.generalInformation.requiresInterruption,
        serviceOrder: '',
        customerId: 0,
        tickerId: 0,
        emergencyComment: accessTicket.generalInformation.emergencyChangeReason,
        accessPermissionId: 0,
        dataCenter: {
            id: accessTicket.generalInformation.headquarters,
            name: headquartersName,
        },
        accessPermissionMotives: getAllAccessPermissionMotives(
            accessTicket.generalInformation.accessMotivesDataCenter,
            accessTicket.generalInformation.accessMotivesJob,
            accessTicket.generalInformation.accessMotivesChange,
            accessTicket.generalInformation.otherMotiveDataCenter,
            accessTicket.generalInformation.otherMotiveJob,
            accessTicket.generalInformation.otherMotiveChange,
            accessTicket.generalInformation.accessReasons,
        ),
        accessPermissionEquipments: getAccessPermissionEquipments(
            accessTicket.hardwareTransfer,
            headquartersName,
        ),
        accessContacts: getAccessContacts(accessTicket.involvedPeople, accessTicket.contactTypeID),
        tasks: getTasks(accessTicket.tasks),
        vehicles: getVehicles(accessTicket.accessCars),
        workflowAccessPermissionsStates: getWorkflowAccessPermissionsStates(accessTicket),
    };
    return accessPermission;
}

function getWorkflowAccessPermissionsStates(accessTicket: FORM_INTERFACE.accessTicketInterface) {
    return Array();
}

function getVehicles(accessCars: FORM_INTERFACE.accessCarsInterface[]) {
    let vehicles: PDT_INTERFACE.vehiclesInterface[] = Array();
    accessCars.forEach((car, index) => {
        vehicles.push({
            id: index,
            licensePlate: car.numberPlate,
            model: car.model,
            brand: car.brand,
        });
    });
    return vehicles;
}

function getTasks(accessTasks: FORM_INTERFACE.tasksInterface[]) {
    let tasks: PDT_INTERFACE.tasksInterface[] = Array();
    accessTasks.forEach((task, index) => {
        tasks.push({
            id: index,
            name: task.description,
            taskType: {
                id: task.person,
                name: '',
                description: '',
            },
        });
    });
    return tasks;
}

function getAccessContacts(
    involvedPeople: FORM_INTERFACE.involvedPeopleInterface,
    contactTypeID: FORM_INTERFACE.contactTypeIdInterface,
) {
    let contacts: PDT_INTERFACE.accessContactsInterface[] = Array();
    for (const key in involvedPeople) {
        if (involvedPeople.hasOwnProperty(key)) {
            involvedPeople[key].forEach((person, index) => {
                contacts.push({
                    id: index,
                    name: person.firstName,
                    lastName: person.lastName,
                    identification: person.hasOwnProperty('idNumber') ? person.idNumber : '',
                    phone: person.hasOwnProperty('telephoneNumber') ? person.telephoneNumber : '',
                    email: person.hasOwnProperty('email') ? person.email : '',
                    company: person.hasOwnProperty('company') ? person.company : '',
                    contactId: 0,
                    contactDetails: getContactDetails(index, key, contactTypeID),
                });
            });
        }
    }
    return contacts;
}

function getContactDetails(
    index: number,
    key: string,
    contactTypeID: FORM_INTERFACE.contactTypeIdInterface,
) {
    let contactDetails: {
        id: number;
        contactType: {
            id: number;
            name: string;
            description: string;
        };
    }[] = Array();
    if (index == 0 && key == 'authorizedPeople') {
        contactDetails.push({
            id: index,
            contactType: {
                id: contactTypeID['responsiblePerson'],
                name: '',
                description: '',
            },
        });
    }
    let offset: number = 0;
    switch (key) {
        case 'authorizedPeople':
            offset = 10;
            break;
        case 'applicant':
            offset = 20;
            break;
        case 'additionalPeople':
            offset = 30;
            break;

        default:
            break;
    }
    contactDetails.push({
        id: index + offset,
        contactType: {
            id: contactTypeID[key],
            name: '',
            description: '',
        },
    });
    return contactDetails;
}

function getAccessPermissionEquipments(
    hardwareTransfer: FORM_INTERFACE.hardwareTransferInterface[],
    headquartersName: string,
) {
    let accessPermissionEquipments: PDT_INTERFACE.accessPermissionEquipmentsInterface[] = Array();
    hardwareTransfer.forEach((hardwareUnit, index) => {
        accessPermissionEquipments.push({
            id: index,
            movementType: {
                id: hardwareUnit.transferInformation.movementType.id,
            },
            destination: hardwareUnit.transferInformation.destination,
            departureMotive: hardwareUnit.transferInformation.motive,
            accessEquipmentDepartureType: hardwareUnit.transferInformation.reasonForTransfer,
            accessEquipmentDeparturePeriodType: hardwareUnit.transferInformation.lengthOfTransfer,
            accessEquipment: {
                id: index,
                serial: hardwareUnit.hardware.serialNumber,
                name: hardwareUnit.hardware.name,
                model: hardwareUnit.hardware.model,
                brand: hardwareUnit.hardware.brand,
                measureUnit: hardwareUnit.hardware.measureUnit,
                voltage: hardwareUnit.hardware.nominalVoltage.replace(',', '.'),
                consumption: hardwareUnit.hardware.nominalConsumption.replace(',', '.'),
                location: headquartersName,
            },
        });
    });
    return accessPermissionEquipments;
}

function getAllAccessPermissionMotives(
    accessMotivesDataCenter: number[],
    accessMotivesJob: number[],
    accessMotivesChange: number[],
    otherMotiveDataCenter: string,
    otherMotiveJob: string,
    otherMotiveChange: string,
    accessReasons: number[],
) {
    let allPermissionMotives: PDT_INTERFACE.accessPermissionMotivesInterface[] = Array();
    accessReasons.forEach(reason => {
        let permissionMotives: PDT_INTERFACE.accessPermissionMotivesInterface[] = Array();
        switch (reason) {
            case 1:
                permissionMotives = getAccessPermissionMotives(
                    accessMotivesDataCenter,
                    otherMotiveDataCenter,
                    reason,
                );
                break;
            case 2:
                permissionMotives = getAccessPermissionMotives(
                    accessMotivesJob,
                    otherMotiveJob,
                    reason,
                );
                break;
            case 3:
                permissionMotives = getAccessPermissionMotives(
                    accessMotivesChange,
                    otherMotiveChange,
                    reason,
                );
                break;

            default:
                break;
        }
        allPermissionMotives.push(...permissionMotives);
    });
    return allPermissionMotives;
}

function getAccessPermissionMotives(motives: number[], otherMotive: string, accessReason: number) {
    let accessPermissionMotives: PDT_INTERFACE.accessPermissionMotivesInterface[] = Array();
    motives.forEach((motive, index) => {
        accessPermissionMotives.push({
            id: index,
            accessMotiveDescription: motive == 20 ? otherMotive : undefined,
            accessPermissionTypeMotive: {
                accessMotive: {
                    id: motive,
                    name: '',
                },
                accessType: {
                    id: accessReason,
                    name: '',
                },
            },
        });
    });
    return accessPermissionMotives;
}

function getCustomer(accessTicket: FORM_INTERFACE.accessTicketInterface) {
    let customer: PDT_INTERFACE.customerInterface = {
        id: 0,
        customerType: 0,
        status: 0,
        rif: '',
        name: accessTicket.involvedPeople.applicant[0].company,
    };
    return customer;
}

function getTyping(accessTicket: FORM_INTERFACE.accessTicketInterface) {
    return {} as PDT_INTERFACE.typingInterface;
}
